<template>
  <el-container class="body_container">
    <el-header style="height: 100px;padding:0px">
      <el-row class="body_title">学习记录</el-row>
      <el-form v-model="searchVo" :inline="true" ref="search">
        <el-row type="flex">
          <el-col>
            <el-form-item  label-width="40px"  size="small" >
              <el-date-picker
                style="width: 150px"
                v-model="searchVo.startTime"
                type="date"
                value-format="yyyy-MM-dd"
                placeholder="选择开始日期">
              </el-date-picker>
              <el-date-picker
                style="width: 150px"
                v-model="searchVo.endTime"
                value-format="yyyy-MM-dd"
                type="date"
                placeholder="选择结束时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item class="dialog-footer" >
              <el-button type="primary" @click="search">查询</el-button>
              <el-button @click="resetForm" style="background-color: #fff;border: 1px solid #3e64ff;color: #3e64ff;padding: 7px 12px">重置</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-header>
    <el-main class="search_result">
      <el-table :data="records.list">
        <el-table-column prop="videoName" :show-overflow-tooltip="true" label="视频名称" width="300px"></el-table-column>
        <!--<el-table-column prop="lawyerName" label="律师名称" width="200px"></el-table-column>-->
        <!--<el-table-column prop="totalTime" label="总时长" width="130px"></el-table-column>-->
        <!--<el-table-column prop="totalScore" label="总分" width="130px"></el-table-column>-->
        <el-table-column prop="videoType" label="视频类型" :formatter="formatterVideoType" min-width="130px"></el-table-column>
        <el-table-column prop="startTime" label="开始时间" min-width="200px"></el-table-column>
        <el-table-column prop="endTime" label="结束时间" min-width="200px"></el-table-column>
        <el-table-column prop="watchingTime" label="观看时间(秒)" min-width="130px"></el-table-column>
        <el-table-column prop="clientType" label="终端类型" :formatter="formatterClientType"  min-width="130px"></el-table-column>
        <!--<el-table-column prop="lawyerId" label="操作">-->
          <!--<template slot-scope="scope">-->
            <!--<el-button-->
              <!--size="mini"-->
              <!--@click="checkPeriod(scope.row)"><i class="qb-icon-caozuo1" style="font-size: 20px"></i></el-button>-->
          <!--</template>-->
        <!--</el-table-column>-->
      </el-table>
    </el-main>
    <el-pagination class="page"
                   @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :page-size="records.rows"
                   :current-page="records.page"
                   layout="prev, pager, next, jumper"
                   :total="records.total">
    </el-pagination>
  </el-container>
</template>

<script>
import period from '@/api/period'
export default {
  name: 'Record',
  data () {
    return {
      value: true,
      lawyerId: this.$route.query.lawyerId,
      addLawyerVisible: false,
      records: {
        page: 1,
        rows: 10,
        total: 0,
        list: []
      },
      searchVo: {
        startTime: '',
        endTime: ''
      },
      value2: '1',
      type: 'H',
      page: 1,
      size: 15
    }
  },
  methods: {
    checkPeriod (row) {
      this.lawyerId = row.id
      // console.log(this.lawyerId)
      this.addLawyerVisible = true
    },
    handleSizeChange (val) {
      // console.log(`每页 ${val} 条`)
    },
    handleCurrentChange (val) {
      // console.log(`当前页: ${val}`)
      this.page = val
      this.reload()
    },
    formatterVideoType (row, column) {
      return row.videoType === 'L' ? '直播' : row.videoType === 'H' ? '历史直播' : row.videoType === 'C' ? '课件' : '未知'
    },
    formatterClientType (row, column) {
      return row.clientType === 'A' ? '安卓' : row.clientType === 'B' ? '浏览器' : row.clientType === 'O' ? '苹果' : '未知'
    },
    reload () {
      period.historicalRecord({lawyerId: this.lawyerId, page: this.page, rows: this.size, startTime: this.searchVo.startTime, endTime: this.searchVo.endTime}).then(res => {
        this.records = res.data.data
      })
    },
    search () {
      this.page = 1
      this.reload()
    },
    // 重置form
    resetForm () {
      this.searchVo.startTime = ''
      this.searchVo.endTime = ''
      this.reload()
    }
  },
  created () {
    // console.log(this.lawyerName)
    this.reload()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lawyer/period/Period.vue